import React from 'react';
import { TrashIcon } from '@heroicons/react/24/outline';

const DeleteConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  complaint
}) => {
  if (!isOpen || !complaint) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-0 overflow-y-auto h-full w-full z-50 animate-in fade-in duration-500">
      <div className="relative top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 p-6 border w-full max-w-md shadow-2xl rounded-lg bg-white animate-in slide-in-from-bottom duration-700 transform-gpu">
        <div className="flex items-center justify-center mb-4 animate-in slide-in-from-top duration-500 delay-200">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 animate-pulse">
            <TrashIcon className="h-6 w-6 text-red-600" />
          </div>
        </div>

        <div className="text-center animate-in slide-in-from-bottom duration-500 delay-300">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Delete Complaint</h3>
          <p className="text-sm text-gray-500 mb-4">
            Are you sure you want to delete the complaint "{complaint.subject}"? This action cannot be undone.
          </p>

          {/* <div className="bg-gray-50 border border-gray-200 rounded-md p-3 mb-4 animate-in slide-in-from-left duration-400 delay-400">
            <div className="text-sm">
              <div className="font-medium text-gray-900">{complaint.subject}</div>
              <div className="text-gray-500">by {complaint.complainant_name}</div>
              <div className="text-xs text-gray-400 mt-1">
                {complaint.complaint_type} • {complaint.priority} priority
              </div>
            </div>
          </div> */}
        </div>

        <div className="flex justify-end gap-3 animate-in slide-in-from-bottom duration-500 delay-500">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-md font-medium transition-all duration-200 hover:scale-105 active:scale-95"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-md font-medium transition-all duration-200 hover:scale-105 active:scale-95 flex items-center gap-2"
          >
            {/* <TrashIcon className="h-4 w-4" /> */}
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;